import API from '../dataApi';

// -- Subscription / Razorpay ---------------------------------------------------
export const createSubscriptionOrder   = (data) => API.post('/subscription/create-order', data);
export const verifyAndRegister          = (data) => API.post('/subscription/verify-and-register', data);
export const verifySubscriptionRenewal  = (data) => API.post('/subscription/verify-renewal', data);
export const offlineRegister            = (data) => API.post('/subscription/offline-register', data);
export const offlineRenewal             = (data) => API.post('/subscription/offline-renewal', data);
